namespace Portico.Directives {
	import ps = Portico.Services;

    export interface ITcTextareaController {
		change: () => void;
		disabled: string;
		inputClass: string;
		key: string;
		maxlength: string;
		minlength: string;
		pattern: string;
		placeholder: string;
		readonly: string;
		required: string;
		rows: string;

		tcForm: ITcFormController;

		isDisabled: () => boolean;
		onChange: () => void;
    }

    export class TcTextareaController implements ITcTextareaController {
		change: () => void;
		disabled: string;
		inputClass: string;
		key: string;
		maxlength: string;
		minlength: string;
		pattern: string;
		placeholder: string;
		readonly: string;
		required: string;
		rows: string;

		tcForm: ITcFormController;

		isDisabled(): boolean {
			return this.disabled === 'true' || (this.tcForm && this.tcForm.isDisabled());
		}

		onChange(): void {
			if (this.change) {
				this.change();
			}
		}
    }

    angular.module('app')
        .directive('tcTextarea', [
			'$compile',
			'$stateParams',
			'dataService', (
				$compile: angular.ICompileService,
				$stateParams: angular.ui.IStateParamsService,
				dataService: ps.IDataService) => {
				return {
					bindToController: {
						change: '&?',
						disabled: '@',
						inputClass: '@',
						key: '@',
						maxlength: '@',
						minlength: '@',
						pattern: '@',
						placeholder: '@',
						readonly: '@',
						required: '@',
						rows: '@'
					},
					controller: <any>TcTextareaController,
					controllerAs: '$textarea',
					link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[]) => {
						const tcTextarea: ITcTextareaController = $ctrl[0];
						const tcForm: ITcFormController = $ctrl[1];

						if (tcForm) {
							tcTextarea.tcForm = tcForm;
							//tcForm.tcInputs.push(tcTextarea);
						}

						const key: string = tcTextarea.key ? tcTextarea.key : '';
						const id: string = key.replace(/[\.\'\$\[\]\(\)]+/g, '_');

						const inputClass = tcTextarea.inputClass ? ' ' + tcTextarea.inputClass : '';
						let inputAttrs = '';

						if (tcTextarea.disabled) {
							inputAttrs += `disabled="${tcTextarea.disabled}" `;
						}

						if (tcTextarea.maxlength) {
							inputAttrs += `ng-maxlength="${tcTextarea.maxlength}" maxlength="${tcTextarea.maxlength}" `;
						}

						if (tcTextarea.minlength) {
							inputAttrs += `ng-minlength="${tcTextarea.minlength}" `;
						}

						if (tcTextarea.pattern) {
							if (tcTextarea.pattern === 'email') {
								inputAttrs += `ng-pattern="/^[a-z0-9!#\$%&'*+\\/=?^_\`{|}~.-]+@[a-z0-9-]+(\\.[a-z0-9-]+)+\$/i" `;
							} else {
								inputAttrs += `ng-pattern="${tcTextarea.pattern}" `;
							}
						}

						if (tcTextarea.placeholder) {
							inputAttrs += `placeholder="${tcTextarea.placeholder}" `;
						}

						if (tcTextarea.readonly) {
							inputAttrs += `readonly="readonly" `;
						}

						if (tcTextarea.required) {
							if (dataService.session.mode !== 'edit' && dataService.session.mode !== 'mock') {
								inputAttrs += `required="required" `;
							}
						}

						if (tcTextarea.rows) {
							inputAttrs += `rows="${tcTextarea.rows}" `;
						}

						const html =
							`<textarea class="form-control ${inputClass}" id="${id}-input" name="${id}" ng-change="$textarea.onChange()" ng-disabled="$textarea.isDisabled()" ng-model="${key}" ${inputAttrs}>
							</textarea>`;

						$element.html(html);
						$compile($element.contents() as any)($scope);
					},
					restrict: 'E',
					require: ['tcTextarea', '?^tcForm'],
					scope: true
				};
			}
		]
	);
}